export default __webpack_public_path__ + "static/media/logo.54ae1e07.svg";